export function isValidConcept(str) {
    const regex = /^[a-zA-Z0-9]{1,}$/; // Comprueba que solo haya letras y números
    
    return regex.test(str);
}

export function isValidConceptMaxDigits(str, maxDigits) {
    const regexDigits = new RegExp(`^[a-zA-Z0-9]{1,${maxDigits}}$`); // Comprueba que la cadena no exceda el número máximo de digitos
  
    return isValidConcept(str) && regexDigits.test(str);
}